import React, { FC } from 'react';
import styled from 'styled-components';
import { FontWeight, TextAlign, TextColor, TEXT_ALIGN, TEXT_COLOR } from 'styles/constants';

interface Props {
	color?: TEXT_COLOR | TextColor | string;
	size?: number;
	lineHeight?: number;
	weight?: FontWeight | number;
	textAlign?: TEXT_ALIGN | TextAlign;
	children?: React.ReactNode;
	whiteSpace?: 'nowrap' | 'normal' | 'pre-wrap';
	textDecoration?: 'underline';
	textTransform?: 'uppercase' | 'lowercase' | 'capitalize';
	dangerouslySetInnerHTML?: {
		__html: string;
	};
}

const StyledTypography = styled.span<Props>`
	color: ${({ theme, color }) => {
		if (!color) return theme.colors.text1 || '#000';
		return Object.values(TEXT_COLOR).includes(color as TEXT_COLOR)
			? theme.colors[color as TextColor]
			: color;
	}};
	display: ${({ textAlign }) => (textAlign ? 'block' : 'inline')};
	text-transform: ${({ textTransform }) => textTransform ?? 'none'};
	text-decoration: ${({ textDecoration }) => textDecoration};
	line-height: ${({ lineHeight }) => lineHeight}px;
	font-size: ${({ size }) => size ?? 14}px;
	text-align: ${({ textAlign }) => textAlign ?? 'left'};
	white-space: ${({ whiteSpace }) => whiteSpace ?? 'normal'};
	font-weight: ${({ weight, theme }) => {
		if (!weight) return 'normal';
		return isNaN(+weight) ? theme.fontWeight[weight as FontWeight] : weight;
	}};
`;

export const Typography: FC<Props> = props => {
	return <StyledTypography {...props}>{props.children}</StyledTypography>;
};
